<i18n>
{
  "en": {
    "home": {
      "errors": {
        "payment": "There was a problem with your payment information. Please reconfirm and try again. If you continue receiving this error, please contact Aces.",
        "other": "There was a problem submitting your reservation. Please try again. If you continue receiving this error, please contact Aces."
      }
    }
  }
}
</i18n>

<template>
  <div>
    <div class="ui grid">
      <div class="sixteen column row">
        <div class="sixteen wide column">
          <Summary v-bind:reservation="reservation" v-if="showSummary()"></Summary>
          <Locations v-bind:quoteInProgress="quoteInProgress" @rideTypeUpdated="onRideTypeUpdated" @locationsSet="onLocationsSet" @locationsComplete="onLocationsComplete" @quoteInProgress="onQuoteInProgress" @quoteReceived="onQuoteReceived" v-if="showLocations()"></Locations>
          <div id="quotes">
            <Quote @selectReservation="onQuoteSelected" v-bind:reservation="reservation" v-if="showQuotes()"></Quote>
          </div>
          <DateTime @dateTimeComplete="onDateTimeComplete" v-if="showDateTime() && rideType !== 'AIRPORTPICKUP'"></DateTime>
          <FlightInfo @meetAndGreetUpdated="onMeetAndGreetUpdated" @flightInfoComplete="onFlightInfoComplete" v-if="showDateTime() && rideType === 'AIRPORTPICKUP'"></FlightInfo>
          <Contact v-bind:authenticated="authenticated" @contactType="onContactType" @contactComplete="onContactComplete" v-if="showContactPrimary()"></Contact>
          <Contact passenger v-if="showContactSecondary()"></Contact>
          <Request @rideType="rideType" @requestUpdated="onRequestUpdate" v-bind:reservation="reservation" v-bind:additionalLineItems="additionalLineItems" v-if="showRequest()"></Request>
          <Confirmation v-if="showConfirmation()" v-bind:reservation="requestedReservation"></Confirmation>
          <div v-if="!confirmed">
            <div class="ui fluid positive button reqbutton" v-bind:class="{ disabled: !requestComplete || requestInProgress, visible: !confirmed, loading: requestInProgress }" v-on:click="completeReservation()">Submit Request</div>
            <div class="ui fluid secondary button reqbutton" v-on:click="reset()">Cancel and Start Over</div>
          </div>
          <div v-else>
            <div class="ui fluid primary button reqbutton" v-on:click="reset()">Make Another Reservation</div>
          </div>

          <div id="errorModal" class="ui modal">
            <div class="header">Sorry, there was a problem!</div>
            <div class="content">
              <p v-for="(error, index) in errors" :key="index">{{ error }}</p>
            </div>
            <div class="actions">
              <div class="ui approve button">Ok</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Summary from './Summary.vue'
  import Locations from './Locations.vue'
  import DateTime from './DateTime.vue'
  import Contact from './Contact.vue'
  import Quote from './Quote.vue'
  import Request from './Request.vue'
  import Confirmation from './Confirmation.vue'
  import FlightInfo from './FlightInfo.vue'

  import { twosteau } from './mixins/clients/twosteau.js'
  import { lumberjacque } from './mixins/clients/lumberjacque.js'
  import { carkclint } from './mixins/clients/carkclint.js'

  import LineItem from '../models/line_item.js'

  export default {
    mixins: [twosteau, carkclint, lumberjacque],
    components: {
      Summary, Locations, DateTime, Contact, Quote, Request, Confirmation, FlightInfo
    },
    name: 'home',
    props: ['auth', 'authenticated'],
    data: function () {
      return {
        // Don't forget to update reset()
        reservation: {},
        locationsComplete: false,
        dateTimeComplete: false,
        contactComplete: false,
        quoteInProgress: false,
        quote: {},
        quotePrice: '',
        isArranger: false,
        apiReservation: {},
        tosAgreed: false,
        requestComplete: false,
        requestedReservation: {},
        confirmed: false,
        rideType: 0,
        additionalLineItems: [],
        paymentFunction: null,
        paymentInProgress: false,
        requestInProgress: false,
        errors: []
      }
    },
    methods: {
      completeReservation: function () {
        this.requestInProgress = true
        this.resolvePayment()
      },
      resolvePayment: function () {
        this.remoteLog('INFO', 'Home.vue', 'Attempting to resolve payment', {'value': JSON.stringify(this.paymentFunction)})
        this.errors = []
        var responseHandler
        if (this.paymentFunction.type === 'cc') {
          responseHandler = (r) => {
            this.remoteLog('INFO', 'Home.vue', 'Resolving payment', {'value': JSON.stringify(r)})
            if (r.messages.resultCode === 'Ok') {
              this.remoteLog('INFO', 'Home.vue', 'Resolving payment successful', {'value': JSON.stringify(r)})
              this.apiReservation.payment = {
                identifier: r.opaqueData.dataValue,
                type: 'NONCE'
              }
            } else {
              this.remoteLog('INFO', 'Home.vue', 'Resolving payment failed', {'value': JSON.stringify(r)})
              this.apiReservation.payment = null
              this.errors = ['Failed to validate payment information. Please try re-entering your information and submitting again.']
            }
            if (this.errors.length === 0) {
              this.requestReservation(this.apiReservation, this.getIdToken())
              this.requestInProgress = true
            } else {
              $('#errorModal').modal('show')
              this.requestInProgress = true
            }
          }
          this.paymentFunction.function(responseHandler)
        } else {
          responseHandler = (r) => {
            this.apiReservation.payment = {
              identifier: r,
              type: 'ACCOUNT_CODE'
            }
            this.requestReservation(this.apiReservation, this.getIdToken())
            this.requestInProgress = true
          }
          this.paymentFunction.function(responseHandler)
        }
      },
      checkIfComplete: function () {
        this.requestComplete = this.tosAgreed && this.paymentFunction.function !== null
      },
      getIdToken: function () {
        return localStorage.id_token
      },
      onQuoteInProgress: function (value) {
        this.quoteInProgress = value
      },
      onLocationsComplete: function (value) {
        // remoteLog: function (level, context, message, values) {
        // var logVals = new Map()
        if (value === true) {
          this.remoteLog('INFO', 'Home.vue', 'Locations complete', {'value': JSON.stringify(value)})
        }
        this.locationsComplete = value
      },
      onDateTimeComplete: function (value) {
        console.log('date val: ' + JSON.stringify(value))
        this.dateTimeComplete = value.complete
        this.apiReservation.pickupDateTime = new Date(value.dateTime).toISOString()
      },
      onFlightInfoComplete: function (value) {
        console.log('complete!')
        this.dateTimeComplete = value.complete
        this.apiReservation.pickupDateTime = value.dateTime
        this.apiReservation.flightInfo = value.flightInfo
      },
      onContactComplete: function (value) {
        this.contactComplete = value.complete
        this.apiReservation.contacts = [value.contact]
      },
      onQuoteReceived: function (value) {
        this.$set(this.reservation, 'quote', value)
        this.quote = value
      },
      onQuoteSelected: function (value) {
        this.$set(this.reservation, 'selectedQuote', value)
        this.apiReservation.quoteInfo = {
          totalFare: value.fares[0].totalFare,
          miles: this.reservation.quote.tripDetails.miles,
          minutes: this.reservation.quote.tripDetails.minutes,
          lineItems: value.fares[0].fareLineItems.map(i => {
            return { type: i.lineItemType, description: i.lineItemDescription, cost: i.lineItemCost }
          })
        }
        this.apiReservation.vehicleRequest = {
          vehicleType: value.vehCode.toUpperCase()
        }
        document.getElementById('quotes').scrollIntoView()
      },
      onLocationsSet: function (value) {
        value.pickup.type = 'PICKUP'
        value.dropoff.type = 'DROPOFF'
        this.$set(this.reservation, 'pickup', value.pickup)
        this.$set(this.reservation, 'dropoff', value.dropoff)

        this.apiReservation.addresses = [this.reservation.pickup, this.reservation.dropoff]
        this.apiReservation.passengers = value.passengers
        this.apiReservation.type = value.rideType
      },
      onContactType: function (value) {
        this.isArranger = (value === 'arranger')
      },
      onRequestUpdate: function (value) {
        this.apiReservation.vehicleRequest.acceptUpgrade = value.upgrades
        this.tosAgreed = value.tosAgreed
        this.paymentFunction = value.paymentFunction
        this.apiReservation.clientNotes = value.clientNotes
        this.checkIfComplete()
      },
      onRideTypeUpdated: function (value) {
        this.rideType = value
        this.reset()
      },
      onMeetAndGreetUpdated: function (value) {
        this.additionalLineItems = this.additionalLineItems.filter(i => i.lineItemType !== LineItem.Types.MEET_AND_GREET)
        if (value === true) {
          this.additionalLineItems.push(new LineItem(15, 'Meet and Greet Service', LineItem.Types.MEET_AND_GREET))
        }
      },
      showDateTime: function () {
        return ('selectedQuote' in this.reservation && !this.confirmed)
      },
      showContactPrimary: function () {
        return this.locationsComplete && this.dateTimeComplete && !this.confirmed
      },
      showContactSecondary: function () {
        return this.showContactPrimary() && this.isArranger && !this.confirmed
      },
      showQuotes: function () {
        return (('tripDetails' in this.quote) && (!this.quoteInProgress)) && !this.confirmed
      },
      showLocations: function () {
        return (!('selectedQuote' in this.reservation)) && !this.confirmed
      },
      showSummary: function () {
        return ('selectedQuote' in this.reservation) && !this.confirmed
      },
      showRequest: function () {
        return this.contactComplete && !this.confirmed
      },
      showConfirmation: function () {
        return this.confirmed
      },
      reset: function () {
        this.reservation = {}
        this.locationsComplete = false
        this.dateTimeComplete = false
        this.contactComplete = false
        this.quoteInProgress = false
        this.quote = {}
        this.quotePrice = ''
        this.isArranger = false
        this.apiReservation = {}
        this.tosAgreed = false
        this.requestComplete = false
        this.requestedReservation = {}
        this.confirmed = false
        // this.rideType = 0
        this.additionalLineItems = []
        this.paymentFunction = null
        this.paymentInProgress = false
        this.requestInProgress = false
        this.errors = []
      }
    },
    mounted () {
      var v = this
      this.$on('requestReceived', function (data) {
        v.requestInProgress = false
        v.requestedReservation = data
        v.confirmed = true
      })
      this.$on('requestFailed', function (data) {
        v.errors = []
        if (data === 402) {
          v.errors = [v.$t('home.errors.payment')]
        } else {
          v.errors = [v.$t('home.errors.other')]
        }
        v.requestInProgress = false
        $('#errorModal').modal('show')
      })
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
  body {
    background-color: #FFFFFF;
  }
  .ui.menu .item img.logo {
    margin-right: 1.5em;
  }
  .main.container {
    margin-top: 7em;
  }
  .wireframe {
    margin-top: 2em;
  }
  .ui.footer.segment {
    margin: 5em 0em 0em;
    padding: 5em 0em;
  }
  .ui.fluid.primary.button.reqbutton, .ui.fluid.positive.button.reqbutton, .ui.fluid.secondary.button.reqbutton {
    margin-bottom: 0.5em;
    margin-top: 0.5em;
  }
</style>




// WEBPACK FOOTER //
// src/components/Home.vue